// extracted by mini-css-extract-plugin
export default {"carousel":"carousel_carousel__WzeAw","slider-container":"carousel_slider-container__Dstmv"};